var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pages"},[_c('pdf',{attrs:{"src":"http://192.168.70.152/group1/M00/00/37/wKhGmGKPTIuAMfVMAAASGfEB5fk341.pdf"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }